"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.App = void 0;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var components_1 = require("components");
var Nav_1 = require("components/Nav");
var Bonbon_svg_1 = __importDefault(require("imgs/Bonbon.svg"));
var views_1 = require("views");
var App = function () { return (react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
    react_1.default.createElement(components_1.AppWrapper, null,
        react_1.default.createElement(components_1.Nav, { logo: Bonbon_svg_1.default, name: "Bonbon" },
            react_1.default.createElement(react_router_dom_1.NavLink, { className: Nav_1.navLink, to: "docs" }, "Docs")),
        react_1.default.createElement(react_router_dom_1.Routes, null,
            react_1.default.createElement(react_router_dom_1.Route, { element: react_1.default.createElement(views_1.Docs, null), path: "docs/*" }),
            react_1.default.createElement(react_router_dom_1.Route, { element: react_1.default.createElement(views_1.Home, null), path: "" }),
            react_1.default.createElement(react_router_dom_1.Route, { element: react_1.default.createElement(views_1.NotFound, null), path: "*" }))))); };
exports.App = App;
